import { ISectionAlertProps } from '@vst/beam';

import { AemFeature } from '@app/components/AdobeExperienceFragments';
import { isUnleashedMaxPlan } from '@app/utils';

const getAemFeatureForTier = (tier: number, productTypeId: string): AemFeature => {
  const aemMap: Record<number, { unleashedMax: AemFeature; unleashed: AemFeature }> = {
    0: { unleashedMax: AemFeature.UNLEASHED_MAX_USAGE_GREEN, unleashed: AemFeature.UNLEASHED_USAGE_GREEN },
    1: { unleashedMax: AemFeature.UNLEASHED_MAX_USAGE_YELLOW, unleashed: AemFeature.UNLEASHED_USAGE_YELLOW },
    2: { unleashedMax: AemFeature.UNLEASHED_MAX_USAGE_RED, unleashed: AemFeature.UNLEASHED_USAGE_RED },
  };

  return isUnleashedMaxPlan(productTypeId) ? aemMap[tier].unleashedMax : aemMap[tier].unleashed;
};

export const getPercentageScoreAndColor = (
  tier: number | null,
  productTypeId: string
): {
  beakPosition: string;
  color: ISectionAlertProps['variant'] | undefined;
  aemFeature: AemFeature | null;
} => {
  if (tier === 0) {
    return { beakPosition: '30%', color: 'success', aemFeature: getAemFeatureForTier(0, productTypeId) };
  }
  if (tier === 1) {
    return { beakPosition: '70%', color: 'warning', aemFeature: getAemFeatureForTier(1, productTypeId) };
  }
  if (tier === 2) {
    return { beakPosition: '95%', color: 'error', aemFeature: getAemFeatureForTier(2, productTypeId) };
  }
  return { beakPosition: '', color: undefined, aemFeature: null };
};
